import React, { ComponentProps, ReactNode } from "react";
import { Routes } from "@Libs/Router/Components/Routes/Routes";
import { Route } from "@Libs/Router/Components/Route/Route";
import { ChoosePaymentMethod } from "./ChoosePaymentMethod/ChoosePaymentMethod";
import { IPaymentMethodProvider } from "../../services/paymentMethods";
import { PaymentMethodType } from "../../types";
import { createFlow } from "@Libs/Flow/services/createFlow";
import { withFlow } from "@Libs/Flow/hocs/withFlow";
import { ConfigurePaymentMethod } from "./ConfigurePaymentMethod/ConfigurePaymentMethod";

export type ISavePaymentPreferencesFlowRoutes =
  | "CHOOSE_PAYMENT_METHOD"
  | "CONFIGURE_PAYMENT_METHOD";

export interface SavePaymentPreferencesFlowState {
  allowedPaymentMethods: PaymentMethodType[];
  enabledPaymentMethods: PaymentMethodType[];
  handlePaymentMethodSelect?: (paymentMethod: PaymentMethodType) => void;
  operationSummary?: ReactNode;
  paymentFormInfo?: ReactNode;
}

export const SavePaymentPreferencesFlow = createFlow<
  {
    provider: IPaymentMethodProvider<PaymentMethodType>;
    paymentMethod: PaymentMethodType;
  },
  SavePaymentPreferencesFlowState
>({
  root: "ROOT",
  state: {
    allowedPaymentMethods: [],
    enabledPaymentMethods: [],
    operationSummary: null,
  },
});

export const SavePaymentPreferences = withFlow(
  SavePaymentPreferencesFlow,
  () => {
    return (
      <Routes>
        <Route
          fragments="CHOOSE_PAYMENT_METHOD"
          element={<ChoosePaymentMethod showPayPalAsPaymentMethod={true} />}
        />
        <Route
          fragments="CONFIGURE_PAYMENT_METHOD"
          element={<ConfigurePaymentMethod />}
        />
        <Route
          fragments="ROOT"
          element={<ChoosePaymentMethod showPayPalAsPaymentMethod={true} />}
        />
      </Routes>
    );
  }
);

export type ISavePaymentPreferencesProps = ComponentProps<
  typeof SavePaymentPreferences
>;
